import { render, staticRenderFns } from "./upload-file.vue?vue&type=template&id=7ca64d48&scoped=true"
import script from "./upload-file.vue?vue&type=script&lang=js"
export * from "./upload-file.vue?vue&type=script&lang=js"
import style0 from "./upload-file.vue?vue&type=style&index=0&id=7ca64d48&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca64d48",
  null
  
)

export default component.exports